import WS from 'ourwill-feutil/broswer/ws';
import conf from '@services/config';
import wsDecode from 'ourwill-feutil/common/wsDecode';
import { inflateSync, strFromU8 } from 'fflate';

const wsUrls = {
	dev: ['wss://ws0.inmuu.com/ws/liveadmin/'],
	beta: ['wss://ws-b.cdinmu.com/ws/liveadmin/'],
	v1: ['wss://ws.cdinmu.com/ws/liveadmin/'],
};
const urls = wsUrls[conf.key];
const wsUrl = urls[Math.floor(Math.random() * urls.length)];
const getWsUrl = (id) => `${wsUrl}${id || +new Date()}`;

export const ws = {
	install: function (Vue, options) {
		if (Vue.prototype.$ws) {
			return;
		}
		Vue.prototype.$ws = function (ev, userId) {
			let event = '';
			if (!ev) {
				// ev 传入空字符串清空订阅, 传入false或不传不修改订阅
				event = ev;
			} else {
				event = `${conf.key}-activity:${ev}`;
			}

			let url;

			// 传入userId时重新请求，ps: 当用户信息发生改变时，重新调用
			if (userId) {
				url = getWsUrl(userId);
				// ws.getWs(null, null, '');
				// ws.single = null;
				// ws.ws = null;
			}

			return WS.getWs(
				url,
				async (data) => {
					try {
						return wsDecode({
							data: data.data,
							inflate: (data) => strFromU8(inflateSync(new Uint8Array(data))),
							fetchUrl: conf.wsPullUrl,
						});
					} catch (error) {
						return {
							ev: 'error',
							data: {},
						};
					}
				},
				event,
			);
		};
	},
};
export const url = {
	url: 'wss://ws.ourwill.cn/channel/json/liveadmin/guest',
};
